import qs from 'qs'
import { FuelStatisticFilter } from '../models'
import axiosClient from './axiosClient'

const PATH = '/fuel-statistic'

export const fuelStatisticApi = {
  getFuelStatistic: (fuelStatisticFilter: FuelStatisticFilter) =>
    axiosClient.get(PATH, {
      params: fuelStatisticFilter,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),
}
